angular.module("stepProgressBar.components", []).component("stepProgressBar", {
  templateUrl: "ng/components/stepProgressBar/stepProgressBar.view.html",
  bindings: {
    numberOfElement: "<",
    practiceDetailStatus: "<",
    titleValues: "<"
  },
  controllerAs: "stepProgressBarCtrl",
  controller: function stepProgressBarController() {
    var self = this;

    self.$onInit = function() {
      self.titles = self.titleValues;
      self.numberOfElement = self.numberOfElement;
      self.percentualeElemento = 100 / self.numberOfElement;
      self.practiceDetailStatus = parseInt(self.practiceDetailStatus);
      self.singleStatus = (self.practiceDetailStatus / self.percentualeElemento) -1;
      self.array = new Array(self.numberOfElement).fill(0).map(function(x) {
        return Math.random();
      });
    };
  }
});
